module.exports = __webpack_public_path__ + "static/media/logo_big.e8b35463.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_big.png
// module id = 473
// module chunks = 0